export enum EnterCodeResponses {
  DEFAULT,
  NEXT,
  BACK,
  LIMIT,
}
